import { createSlice } from '@reduxjs/toolkit';
import type { creditType, creditsResponse } from '@repo/customer-api';

export type creditsDataModel = {
  Mora: boolean;
  Credits: creditType[];
  selectedCredit: creditType | null;
};

const initialState: creditsDataModel = {
  Mora: false,
  Credits: [],
  selectedCredit: null,
};

export const creditsSlice = createSlice({
  name: 'creditsSlice',
  initialState,
  reducers: {
    pushCreditsData: (state, action: { payload: creditsResponse }) => ({
      ...state,
      Mora: action.payload.Mora,
      Credits: action.payload.Credits,
    }),
    setSelectedCredit: (state, action: { payload: creditType | null }) => ({
      ...state,
      selectedCredit: action.payload,
    }),
    resetCreditsData: () => {
      return initialState;
    },
  },
});

export const { pushCreditsData, setSelectedCredit, resetCreditsData } = creditsSlice.actions;

export default creditsSlice.reducer;
